<p-toast  [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="card breadcrumbs custom-breadcrumb">
    <ul class="managerlist-outer">
        <li class="current-link">
            <span>Manage Users</span>
        </li>
        <li><p-button  *ngIf="createManagerCheck" (onClick)="createManager()" label="Create Manager" styleClass="p-button-outlined mb-0"></p-button></li>
    </ul>

</div>
<div class="filter-list">
    <div class="booking-inner">
        <div class="filter-outer">
            <div class="filter-inner">
                <h4>Manager Name</h4>
                <input type="text" [(ngModel)]="searchManagerName" pInputText class="p-inputtext-sm" placeholder="Small"
                    placeholder="Enter Name" 
                    (keydown.enter)="filters()"/>
            </div>
        </div>
        <div class="filter-outer">
            <div class="filter-inner">
                <h4>Mobile No.</h4>
                <input type="text" [(ngModel)]='searchContactNo' pInputText class="p-inputtext-sm" placeholder="Small"
                    placeholder="Enter Number"
                    (keydown.enter)="filters()" />
            </div>
        </div>
        <div class="filter-btn">
            <p-button label="Apply" (onClick)="filters()"></p-button>
            <p-button styleClass="p-button-outlined" label="Reset" (onClick)="reset()"></p-button>
        </div>
    </div>
</div>

<div class="driver-leaderb manager-list">
    <div class="grid">
        <div class="col-12 custom-leftright margin-spacing">
            <div class="driver-outer">
                <div class="vparking-outer">
                    <div class="top-heading">
                        <h4>Manager User List </h4>
                    </div>
                </div>
                <div class="dashboard-table custom-history" [class.mangerlist-outer1]="managerlist.length==0">
                    <div class="card">
                        <p-table [value]="managerlist" [tableStyle]="{'min-width': '60rem'}">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th scope="col" class="driver-name" pSortableColumn="name">Name<p-sortIcon
                                            field="name"></p-sortIcon></th>
                                    <th scope="col" pSortableColumn="isActive">Status <p-sortIcon field="isActive"></p-sortIcon>
                                    </th>
                                    <th scope="col" pSortableColumn="contactNumber">Mobile number <p-sortIcon
                                            field="contactNumber"></p-sortIcon>
                                    </th>
                                    <th scope="col" pSortableColumn="email">Email<p-sortIcon field="email"></p-sortIcon></th>
                                    <th scope="col" pSortableColumn="createdOn" class="recent-booking">Created On<p-sortIcon
                                            field="createdOn"></p-sortIcon>
                                    </th>
                                    <th scope="col" pSortableColumn="parkingAssign">Assigned Lots<p-sortIcon
                                            field="parkingAssign"></p-sortIcon></th>
                                    <th scope="col">Password
                                    </th>
                                    <th scope="col"> Actions</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                                <tr class="border12">
                                    <td class="driver-name table-img">
                                        <div class="first-td">
                                            <img [src]="rowData.profileImagePath  || dummy" alt="Profile">
                                            <p>{{ rowData.name }}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            class="active-status {{ rowData.isActive === true ? 'active-status ' : 'inactive-status' }}">
                                            <span></span>{{ rowData.isActive === true ? 'Active' : 'Inactive' }}
                                        </div>
                                    </td>
                                    <td>
                                        {{ rowData.contactNumber 
                                          ? rowData.contactNumber.slice(0, 3) + ' ' + rowData.contactNumber.slice(3, 6) + ' ' + rowData.contactNumber.slice(6) 
                                          : '_' }}
                                      </td>
                                    <td>{{ rowData.email }}</td>
                                    <td>{{ rowData.createdOn| date:'mediumDate' }}
                                    </td>
                                    <td>
                                        <div class="parking-arrows"><img (click)="openSidebarAndLoadParking(rowData.id)"
                                                src="assets/images/parking-arrow.svg" alt="" />
                                            <p>{{ rowData.parkingAssign }}</p>
                                        </div>
                                    </td>

<td >
                                        <div class="custom-pass">
                                            <p-password [(ngModel)]="rowData.password" [toggleMask]="true"
                                                [disabled]="true"></p-password>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="export-btn">

                                            <div>
                                                <img (click)="activeItem = rowData;showData(rowData);menu.toggle($event)"
                                                    src="assets/images/dashboard-dot.svg" alt="" />
                                            </div>

                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage" let-columns>
                                <tr>
                                    <td class="no-record" colspan="8">
                                        No Record Found
                                    </td>
                                </tr>
                            </ng-template>

                        </p-table>
                        <p-sidebar [(visible)]="sidebarVisible" position="right">
                            <div class="custom-side">
                                <div class="side-topheader">
                                    <div class="left-img">
                                        <div class="list-img"
                                            *ngIf="sideBardata.profileImagePath != '' && sideBardata.profileImagePath != null ;else dummyProfile">
                                            <img src={{sideBardata.profileImagePath}} alt=""/>
                                        </div>
                                        <ng-template #dummyProfile>
                                            <img src={{dummy}} alt=""/>
                                        </ng-template>
                                        <div class="side-heading">  
                                            <h5>
                                                {{sideBardata.managerName ||''}}
                                            </h5>
                                            <p>Parking Lots ({{sideBardata.parkingCount}})</p>
                                        </div>
                                    </div>
                                    <div class="close-icon">
                                        <img src="assets/images/export-close.svg" (click)="sideBar()" alt=""/>

                                    </div>
                                </div>
                                <div *ngFor="let location of sideBardata.parkingLot" class="sublist">
                                    <div class="list-heading">
                                        <h5>{{ location.name }}</h5>
                                        <p>{{ location.address }}</p>
                                    </div>
                                </div>

                            </div>
                        </p-sidebar>

</div>
                </div>
             
                <div class="card flex justify-content-end custom-pagination transaction-outer" *ngIf="managerlist.length>0" >
                    <p-paginator  [rows]="itemsPerPage" [totalRecords]="totalItems" (onPageChange)="onPageChange($event)"></p-paginator>
                  </div>

            </div>
        </div>
    </div>
    <div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
    </div>
</div>